import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';

const ServiceCard = ({ icon, title, description, onClick }) => {
  return (
    <Card
      sx={{
        textAlign: 'center',
        p: {xs:1, md:2},
        height: '100%',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: 3,
          transform: 'translateY(-2px)',
        },
      }}
      onClick={onClick}
    >
      <CardContent>
        <Box sx={{ mb: 2, fontSize: { xs: '32px', md: '48px' } }}>
          {icon}
        </Box>
        <Typography variant="h6" component="h3" gutterBottom>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '16px', md: '20px' } }}>
            {description}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default ServiceCard;